import React from 'react';

import FieldError from '../../form/FieldError';
import InlineValue from '../InlineValue';
import Editor from './Editor';

const Number = {

  // Sub-components
  designer: (props) => {
    const {
      containerClassName,
      containerStyle,
      input,
      labelClassName,
      meta,
      wrapperClassName,
      wrapperStyle,
    } = props;
    // console.log('Number designer: ', props);

    const designer = (
      <div className={wrapperClassName} style={wrapperStyle}>
        <label className={labelClassName}>Default Value</label>
        <div className={containerClassName} style={containerStyle}>
          <input
            type="number"
            className={'form-control'}
            placeholder="Enter a number"
            {...input}
          />
          {meta && <FieldError meta={meta} />}
        </div>
      </div>
    );
    return designer;
  },

  display: ({ toggleEditor, userMode, value }) => {
    // console.log('Number display: ', value);

    const clickToEdit = (userMode !== 'reader')
      ? <span className="clickToEdit">Click to edit</span>
      : null;
    const displayValue = (
      <InlineValue toggleEditor={toggleEditor} userMode={userMode}>
        {value || clickToEdit}
      </InlineValue>
    );
    return displayValue;
  },

  editor: Editor,
};

export default Number;



// WEBPACK FOOTER //
// ./src/components/types/Number/Number.js